import { styled } from 'styled-components';

export const Wrapper = styled.div`
  height: var(--height-full);
`;
